<template>
  <div class="compare-operations">
    {{ posState }}
    <button @click="reconnect" v-if="posState === 'error'">reconnect</button>
    <button @click="loadCompareDataset" v-if="appState === 'ready'">
      start
    </button>
    <div class="compare-operations__table"></div>
  </div>
</template>

<script>
import { POS_WS_URL } from "@/const/pos";
import { Pos } from "@/services/pos/pos";
import { PosWs } from "@/services/pos/pos-ws";
import { PosApi } from "@/office/pos/pos-api";
import XPAYReportOperation from "@/entity/XPAYReportOperation";
import POSReportOperation from "@/entity/POSReportOperation";

export default {
  name: "CompareOperations",
  components: {},
  data() {
    return {
      posState: "idle",
      posConnection: null,
      appState: "waiting",
      posOperations: [],
      xpayOperations: [],
      terminalInfo: {},
    };
  },

  POS_SERVICE: new Pos(),
  created() {
    this.getXPAYOperationsByTerminal();
  },
  watch: {
    posState() {
      if (this.posState === "connected") {
        this.getTerminalInfo();
      }
    },
  },
  computed: {
    operationsMerged() {
      const _operations = [];
      this.xpayOperations.forEach((_operation) => {
        _operation = new XPAYReportOperation(_operation);

        let _posOperationIndex = this.posOperations.find(
          (_posOperation) =>
            _operation.posData?.trans_rcpt === _posOperation?.trans_rcpt
        );

        let _posOperation = null;

        if (_posOperationIndex) {
          _posOperation = new POSReportOperation(
            this.posOperations[_posOperationIndex]
          );

          this.posOperations.splice(_posOperationIndex, 1);
        }

        _operations.push({
          operationCreatedDate: _operation.dateTime.date,
          operationCreatedTime: _operation.dateTime.time,
          operationAmount: _operation.amount,
          operationStatus: _operation.status,
          posOperationCreatedDate: _posOperation?.dateTime.date ?? "-",
          posOperationCreatedTime: _posOperation?.dateTime.time ?? "-",
          posOperationAmount: _posOperation?.amount ?? "-",
          posOperationStatus: _posOperation?.status ?? "-",
        });
      });

      this.posOperations.forEach((_posOperation) => {
        _posOperation = new POSReportOperation(_posOperation);

        _operations.push({
          operationCreatedDate: "-",
          operationCreatedTime: "-",
          operationAmount: "-",
          operationStatus: "-",
          posOperationCreatedDate: _posOperation?.dateTime.date,
          posOperationCreatedTime: _posOperation?.dateTime.time,
          posOperationAmount: _posOperation?.amount,
          posOperationStatus: _posOperation?.status,
        });
      });

      return _operations;
    },
  },
  methods: {
    initiateConnection() {
      this.posState = "connecting";
      this.posConnection = new PosWs({
        onOpen: () => {
          this.posState = "connected";
        },
        onClose: (event) => {
          if ([1002].includes(event.code) || !event.wasClean) {
            this.posState = "error";
          } else {
            if (this.appState !== "ready") {
              this.posState = "closed";
            }
          }
        },
      });
      this.posConnection.open(POS_WS_URL, 5000);
    },
    reconnect() {
      this.posState = "connecting";
      this.posConnection?.reconnect?.();
    },
    async loadCompareDataset() {
      if (this.appState !== "ready") {
        return;
      }

      await this.getTransactionsCount();
      await this.getXPAYOperationsByTerminal();
    },
    async getXPAYOperationsByTerminal() {
      const xpayOperationsResponse = await new PosApi().getOperations(
        this.terminalInfo.merchantId ?? "030050000000011",
        this.terminalInfo.terminalId ?? "00000001"
      );

      this.xpayOperations = xpayOperationsResponse.data.operations ?? [];
    },
    async getTerminalInfo() {
      const terminalInfo = await this.posConnection.sendSync(
        this.$options.POS_SERVICE.formatMessageObjectByAction(
          this.$options.POS_SERVICE.POS_ACTIONS.POS_INFO,
          {
            [this.$options.POS_SERVICE.POS_INFO_PARAMS.HOST]: 1,
          }
        )
      );

      this.terminalInfo = {
        merchantId: terminalInfo.merchant_id,
        terminalId: terminalInfo.terminal_id,
      };

      this.getXPAYOperationsByTerminal();
      this.appState = "ready";
    },
    async getTransactionsCount() {
      const response = await this.posConnection.sendSync(
        this.$options.POS_SERVICE.formatMessageObjectByAction(
          this.$options.POS_SERVICE.POS_ACTIONS.TRANSACTIONS_COUNT
        )
      );

      const transactionIndexes = parseInt(response.data);

      for (let i = 1; i <= transactionIndexes; i++) {
        const operation = await this.getTransactionInfo(i);
        this.posOperations.push(operation);
      }
    },
    async getTransactionInfo(transactionIndex) {
      return await this.posConnection.sendSync(
        this.$options.POS_SERVICE.formatMessageObjectByAction(
          this.$options.POS_SERVICE.POS_ACTIONS.TRANSACTION_INFO,
          {
            [this.$options.POS_SERVICE.TRANSACTION_INFO_PARAMS
              .TRANSACTION_INDEX]: transactionIndex,
          }
        )
      );
    },
  },
};
</script>

<style scoped></style>
